import type React from 'react';
import { ReputationCard } from '../../Reputation/ReputationCard';
import { ActivityStrip } from './ActivityStrip';
import { DomainsInterestsTile } from './DomainsInterestsTile';
import { ProfileHeader } from './ProfileHeader';
import './ProfileOverview.scss';

interface ProfileOverviewProps {
  username: string;
  displayName?: string | null;
  avatar?: string | null;
  role?: string;
  followerCount?: number | null;
  followingCount?: number | null;
  joinLabel?: string | null;
  lastActiveLabel?: string | null;
  reputation: Parameters<typeof ReputationCard>[0]['reputation'];
  domains?: string[];
  interests?: string[];
  interestsHref?: string | null;
  postCount?: number;
  vouchesGiven?: number | null;
  vouchingSlot?: React.ReactNode;
}

export function ProfileOverview(props: ProfileOverviewProps) {
  const {
    username,
    displayName,
    avatar,
    role,
    followerCount,
    followingCount,
    joinLabel,
    lastActiveLabel,
    reputation,
    domains,
    interests,
    interestsHref,
    postCount,
    vouchesGiven,
    vouchingSlot,
  } = props;

  return (
    <div className="profile-overview">
      <div className="profile-overview__grid">
        <div className="profile-overview__tile profile-overview__cell--header">
          <ProfileHeader
            username={username}
            displayName={displayName}
            avatar={avatar}
            role={role}
            followerCount={followerCount}
            followingCount={followingCount}
            joinLabel={joinLabel}
          />
        </div>

        <div className="profile-overview__tile profile-overview__cell--rep">
          <ReputationCard username={username} reputation={reputation} />
        </div>

        <div className="profile-overview__right">
          {vouchingSlot ? (
            <div className="profile-overview__tile profile-overview__vouch">
              {vouchingSlot}
            </div>
          ) : null}
          <div className="profile-overview__tile">
            <DomainsInterestsTile
              domains={domains}
              interests={interests}
              interestsHref={interestsHref}
            />
          </div>
        </div>

        <div className="profile-overview__tile profile-overview__cell--activity">
          <ActivityStrip
            postCount={postCount}
            vouchesGiven={vouchesGiven}
            lastActiveLabel={lastActiveLabel}
          />
        </div>
      </div>
    </div>
  );
}
